import type { FieldValues, Path } from "react-hook-form";
import type { ResourceSelectFieldProps } from "~/components/Form";
import { ResourceSelectField } from "~/components/Form";
import { useCommonResourcesContextValue } from "./context";

export function RoleSelect<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
>(props: ResourceSelectFieldProps<TFieldValues, TName>) {
  const { createRoleListQueryOptions, createRoleFetchQueryOptions } =
    useCommonResourcesContextValue();

  return (
    <ResourceSelectField
      {...props}
      createListQueryOptions={(text) =>
        createRoleListQueryOptions({
          nameLike: text,
          limit: 5,
          sort: "asc",
          order: "name",
        })
      }
      createFetchQueryOptions={createRoleFetchQueryOptions}
      selectOption={(role) => ({
        value: role.id,
        label: role.name,
      })}
    />
  );
}
